"use strict";

export const PARTIAL_AUTH_ERROR_EVENT = 'relay:partial-auth-error';
export const emitPartialAuthError = errors => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(PARTIAL_AUTH_ERROR_EVENT, {
    detail: {
      errors
    }
  }));
};